var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import TaskModelService from "../Domain/Task/Task.service";
import ActionPlanService from "../Domain/ActionPlan/ActionPlan.service";
import TaskTemplateDomainService from "../Domain/TaskTemplate/TaskTemplate.service";
import ActionPlanTemplateDomainService from "../Domain/ActionPlanTemplate/ActionPlanTemplate.service";
import DateService from "./Shared/Date.service";
import TaskStatusService from "../Domain/TaskStatus/TaskStatus.service";
const BASE_URL = "/aviso/task";
const serializeDateForTaskController = (date) => `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
export const editFormStateToUpdateTaskTaskArgType = (taskId, formState) => {
    var _a;
    const saveTaskArgs = {};
    saveTaskArgs.id = taskId;
    saveTaskArgs.title = formState.title;
    saveTaskArgs.description = formState.description;
    saveTaskArgs.assignedPersonAffiliationId =
        (_a = formState.assignedPerson) === null || _a === void 0 ? void 0 : _a.affiliationId;
    saveTaskArgs.associatedPeople = (formState.associatedPeople || []).map((person) => person.personId);
    saveTaskArgs.isKeyEngagement = formState.isKeyEngagement;
    saveTaskArgs.isPrivate = formState.isPrivate;
    saveTaskArgs.priorityId = formState.priority.id;
    saveTaskArgs.statusId = formState.status.id;
    saveTaskArgs.resources = (formState.resources || []).map((resource) => resource.id);
    saveTaskArgs.startDate = formState.startDate;
    saveTaskArgs.dueDate = formState.dueDate;
    // @ts-expect-error - TS2740 - Type 'Record<string, any>' is missing the following properties from type 'UpdateTaskTaskArgType': id, title, statusId, priorityId, and 5 more.
    return saveTaskArgs;
};
export default class TaskService {
    static getTask(taskId) {
        return FetchService.getSingleResponse(BASE_URL + "/task", {
            taskId,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((resp) => TaskModelService.fromJSON(resp.task));
    }
    static getActionPlan(actionPlanId) {
        return FetchService.getSingleResponse(BASE_URL + "/actionPlan", {
            actionPlanId,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((resp) => ActionPlanService.fromJSON(resp.plan));
    }
    static getActionPlanTemplate(actionPlanTemplateId) {
        return FetchService.getSingleResponse(BASE_URL + "/getActionPlanTemplate", {
            id: actionPlanTemplateId,
        }).then(ActionPlanTemplateDomainService.fromJSON);
    }
    static getActiveTasksForAffiliation(affiliationId, options) {
        return FetchService.getSingleResponse(BASE_URL + "/getActiveTasks", Object.assign({ affiliationId }, options)).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'task' implicitly has an 'any' type.
            tasks: resp.tasks.map((task) => TaskModelService.fromJSON(task)) })));
    }
    // Returns all active tasks for the current user
    static searchActiveForCurrentUser(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const pagedResponse = yield FetchService.getPagedResponse(BASE_URL + "/searchForCurrentUser", {
                statusIds: TaskStatusService.ActiveStatuses.map((status) => status.id),
                startDateBefore: new Date(),
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, pagedResponse), { data: pagedResponse.data.map(TaskModelService.fromJSON) });
        });
    }
    static getCountsOfTasksForAffiliation(affiliationId) {
        return FetchService.getSingleResponse(BASE_URL + "/tasksCount", {
            affiliationId,
        });
    }
    static getAllTasksForAffiliation(affiliationId, options) {
        return FetchService.getSingleResponse(BASE_URL + "/getAllTasks", Object.assign({ affiliationId }, options)).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'task' implicitly has an 'any' type.
            tasks: resp.tasks.map((task) => TaskModelService.fromJSON(task)) })));
    }
    static getCompletedTasksForAffiliation(affiliationId, options) {
        return FetchService.getSingleResponse(BASE_URL + "/getCompletedTasks", Object.assign({ affiliationId }, options)).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'task' implicitly has an 'any' type.
            tasks: resp.tasks.map((task) => TaskModelService.fromJSON(task)) })));
    }
    static getActiveActionPlansForAffiliation(affiliationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getActiveActionPlansForAffiliation", {
            affiliationId,
        }).then((resp) => resp.plans.map(ActionPlanService.fromJSON));
    }
    static getAllActionPlansForAffiliation(affiliationId) {
        return FetchService.getSingleResponse(BASE_URL + "/getAllActionPlansForAffiliation", {
            affiliationId,
        }).then((resp) => resp.plans.map(ActionPlanService.fromJSON));
    }
    static getTasksAboutPeopleOnMyCaseload(filters, offset = 0, max = 50, personType) {
        return FetchService.getSingleResponse(`${BASE_URL}/tasksAboutPeopleOnMyCaseload`, Object.assign(Object.assign({}, filters), { offset, max, personType })).then((resp) => {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'task' implicitly has an 'any' type.
            return resp.tasks.map((task) => TaskModelService.fromJSON(task));
        });
    }
    static searchActionPlanTemplates(query, includeDisabledTemplates = false) {
        return FetchService.getSingleResponse(BASE_URL + "/actionPlanTemplates", {
            query,
            includeDisabledTemplates,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((resp) => resp.plans);
    }
    static searchTemplates(query = "", includeDisabledTemplates = false) {
        return FetchService.getSingleResponse(BASE_URL + "/templates", {
            query,
            includeDisabledTemplates,
        });
    }
    static getTaskFromTemplate(regardingPersonAffiliationId, templateId) {
        return FetchService.getSingleResponse(BASE_URL + "/taskFromTemplate", {
            regardingPersonAffiliationId,
            templateId,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((resp) => resp.task);
    }
    static getTemplate(templateId) {
        return FetchService.getSingleResponse(BASE_URL + "/template", {
            templateId,
        }).then(TaskTemplateDomainService.fromJSON);
    }
    static getRequestFromBulkTaskFormState(formState) {
        var _a, _b, _c, _d, _e;
        return {
            title: formState.title,
            description: formState.description,
            statusId: (_a = formState.status) === null || _a === void 0 ? void 0 : _a.id,
            priorityId: (_b = formState.priority) === null || _b === void 0 ? void 0 : _b.id,
            assignedPerson: formState.assignedPerson.value,
            startDate: formState.startDate &&
                DateService.getStartOfDay(formState.startDate.toDate()),
            dueDate: formState.dueDate &&
                DateService.getStartOfDay(formState.dueDate.toDate()),
            resources: (_c = formState.resources) === null || _c === void 0 ? void 0 : _c.map((r) => r.id),
            isPrivate: formState.isPrivate,
            isKeyEngagement: formState.isKeyEngagement,
            associatedPeople: (_d = formState.associatedPeople) === null || _d === void 0 ? void 0 : _d.map((p) => p.personId),
            peopleToNotifyIds: (_e = formState.peopleToNotify) === null || _e === void 0 ? void 0 : _e.map((p) => p.personId),
        };
    }
    static createForPersonPopulation(populationId, formState) {
        return FetchService.postSingleResponse(BASE_URL + "/createForPersonPopulation", {
            populationId,
            task: this.getRequestFromBulkTaskFormState(formState),
        });
    }
    /**
     * Tasks are created asynchronously.
     */
    static createTasks({ personIds, formState, }) {
        return FetchService.postSingleResponse(BASE_URL + "/createTaskForPeople", {
            peopleIds: personIds,
            task: this.getRequestFromBulkTaskFormState(formState),
        });
    }
    static createActionPlanForPersonPopulation(populationId, actionPlanTemplateId) {
        return FetchService.postSingleResponse(BASE_URL + "/createActionPlanForPersonPopulation", {
            populationId,
            actionPlanTemplateId,
        });
    }
    static searchPeopleThatCanAccessTasks(query) {
        return FetchService.get(BASE_URL + "/peopleThatCanAccessTasks", { query });
    }
    static searchPeopleToAssociate(query = "", max = 20) {
        return FetchService.getSingleResponse(BASE_URL + "/peopleThatCanBeAssociated", {
            query,
            isStudent: false,
            max,
        });
    }
    static searchResourcesToAssociate(query = "", max = 20) {
        return FetchService.getSingleResponse(BASE_URL + "/getListOfResourcesForTasks", {
            query,
            max,
        });
    }
    static createTask(task, notifyPeople) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", {
                task: Object.assign(Object.assign({}, task), { startDate: task.startDate && serializeDateForTaskController(task.startDate), dueDate: task.dueDate && serializeDateForTaskController(task.dueDate) }),
                notifyPeople,
            }).then(TaskModelService.fromJSON);
        });
    }
    static updateTask(task, options) {
        return FetchService.putSingleResponse(BASE_URL + "/updateTask", {
            task: Object.assign(Object.assign({}, task), { startDate: task.startDate && serializeDateForTaskController(task.startDate), dueDate: task.dueDate && serializeDateForTaskController(task.dueDate) }),
            notifyPeople: options.peopleToNotify || [],
            comment: options.comment || "",
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((response) => TaskModelService.fromJSON(response.task));
    }
    static updateTaskStatus(taskId, statusId, options = {}) {
        console.log("options", options);
        return FetchService.putSingleResponse(BASE_URL + "/updateTaskStatus", {
            taskId,
            statusId,
            comment: options.comment || "",
            notifyPeople: options.notifyPersonIds || [],
            // @ts-expect-error - TS2345 - Argument of type '({ task }: { task: any; }) => Task' is not assignable to parameter of type '(value: unknown) => Task | PromiseLike<Task>'.
        }).then(({ task }) => TaskModelService.fromJSON(task));
    }
    static assignActionPlanToStudent(studentAffiliationId, actionPlanTemplateId) {
        return FetchService.postSingleResponse(BASE_URL + "/assignActionPlanToStudent", { studentAffiliationId, actionPlanTemplateId });
    }
    // prettier-ignore
    static getBulkAssignedPeoplePrototypes() {
        return FetchService.getSingleResponse("/aviso/task/bulkAssignedPeopleProtos");
    }
    static canPersonBeAssignedToTask(personId) {
        return FetchService.getSingleResponse(BASE_URL + "/canPersonBeAssignedToTask", { personId });
    }
    static assignOpportunitiesTask(opportunityIds, pipelineId, assignedPerson, title, taskStatusId, taskPriorityId, description, startDate, dueDate, templateId, isPrivate, isKeyEngagement, regardingPersonAffiliationId, notifyPeopleIds) {
        return FetchService.postSingleResponse(BASE_URL + "/assignOpportunitiesTask", {
            opportunityIds,
            pipelineId,
            assignedPersonId: assignedPerson.isPrototype
                ? null
                : assignedPerson.value.personId,
            prototypeKey: assignedPerson.isPrototype
                ? assignedPerson.value.key
                : null,
            title,
            taskStatusId,
            taskPriorityId,
            regardingPersonAffiliationId,
            description,
            startDate,
            dueDate,
            templateId,
            isPrivate,
            isKeyEngagement,
            notifyPeopleIds,
        });
    }
    static assignActionPlanToOpportunities(opportunityIds, pipelineId, actionPlanTemplateId) {
        return FetchService.postSingleResponse(BASE_URL + "/assignActionPlanToOpportunities", {
            opportunityIds,
            pipelineId,
            actionPlanTemplateId,
        });
    }
}
